import moment from 'moment'

import {
  IActivity,
  IActivityCategory,
  IApiActivity,
  IApiActivityCategory,
} from '../interface/IActivity'
import { IApiMenuActivity, IMenuActivity } from '../interface/IMenuActivity'
import { IApiMenuCategory, IMenuCategory } from '../interface/IMenuCategory'
import {
  IApiWaitingCustomer,
  IWaitingCustomer,
} from '../interface/IWaitingCustomer'

class Transformer {
  static transform(data: IApiWaitingCustomer): IWaitingCustomer {
    return {
      activities: data.activities,
      id: data.id,
      wantedAt: data.wanted_at ? moment(data.wanted_at) : undefined,
      customer: {
        id: data.customer.id,
        firstName: data.customer.first_name,
        lastName: data.customer.last_name,
        fullName: data.customer.full_name,
      },
      menuId: data.menu_id,
      isDeleted: false,
      remark: data.remark,
      isOnline: data.is_online,
      order: data.order,
      lastMailSent: data.last_mail_sent ? moment(data.last_mail_sent) : undefined,
    }
  }

  public static transformActivity(apiActivity: IApiActivity): IActivity {
    return {
      deposit: apiActivity.deposit ? apiActivity.deposit : undefined,
      description: apiActivity.description
        ? apiActivity.description
        : undefined,
      duration: apiActivity.duration,
      establishmentDetails: apiActivity.establishment_details,
      id: apiActivity.id,
      image: apiActivity.image ? apiActivity.image : undefined,
      isOnline: apiActivity.is_online,
      isPersonSelectable: apiActivity.person_choice,
      name: apiActivity.name,
      order: apiActivity.order,
      personsAmount: apiActivity.persons_amount
        ? apiActivity.persons_amount
        : undefined,
      price: apiActivity.price ? apiActivity.price : undefined,
      type: 'activity',
      waitTime: apiActivity.wait_time || 0,
      uuid: apiActivity.uuid,
    }
  }

  public static transformCategories(
    apiActivityCategory: IApiActivityCategory,
  ): IActivityCategory {
    return {
      ...apiActivityCategory,
      activities: apiActivityCategory.activities.map(
        Transformer.transformActivity,
      ),
    }
  }

  public static transformMenuActivity(
    apiActivity: IApiMenuActivity,
  ): IMenuActivity {
    return {
      categoryId: apiActivity.parent_id,
      description: apiActivity.description
        ? apiActivity.description
        : undefined,
      id: apiActivity.id,
      image: apiActivity.image,
      name: apiActivity.name,
      order: apiActivity.order,
      personsAmount: apiActivity.persons_amount,
      type: 'menuActivity',
      duration: apiActivity.duration,
      waitTime: apiActivity.wait_time || 0,
      uuid: apiActivity.uuid,
    }
  }

  public static transformMenu(
    categoriesArray: IApiMenuCategory[],
  ): IMenuCategory[] {
    return categoriesArray.map((apiCategory: IApiMenuCategory) => {
      const category: IMenuCategory = {
        id: apiCategory.id,
        image: apiCategory.image,
        name: apiCategory.name,
        order: apiCategory.order,
        parentId: apiCategory.parent_id,
        isMenu: apiCategory.is_menu,
        isOnline: apiCategory.is_online,
        description: apiCategory.description
          ? apiCategory.description
          : undefined,
        type: 'category',
      }
      if (apiCategory.categories) {
        category.categories = Transformer.transformMenu(apiCategory.categories)
      }

      if (apiCategory.activities) {
        category.activities = apiCategory.activities.map(apiActivity =>
          Transformer.transformMenuActivity(apiActivity),
        )
      }

      return category
    })
  }
}

export default Transformer
